<template>
  <div>
    <v-btn color="primary" :to="{ name: 'projects.create' }" class="mb-4">{{ $t('Create project') }}</v-btn>
    <v-row class="mb-3" align="center"
      justify="center">
        <v-col lg="3" sm="6" cols="12">
          <v-select
            :items="statusFillter"
            :label="$t('Status')"
            :item-text="__attr"
            v-model="configDatatale.paramsRequest.status"
            outlined
            dense
            hide-details
          ></v-select>
        </v-col>
        <v-col lg="4" sm="6" cols="12">
          <v-row>
             <v-col md="6">
                <datepicker v-model="configDatatale.paramsRequest.from_date" :label="$t('From date')"/>
             </v-col>
             <v-col md="6">
               <datepicker v-model="configDatatale.paramsRequest.to_date" :label="$t('To date')"/>
             </v-col>
          </v-row>
        </v-col>
        <v-col lg="3" sm="6" cols="12">
          <v-text-field
            v-model="configDatatale.paramsRequest._search"
            append-icon="mdi-magnify"
            :label="$t('Key word')"
            outlined
            dense
            hide-details
            @keydown.enter="handleSearch($event)"
          />
        </v-col>
        <v-col lg="2" sm="6" cols="12">
          <v-btn
            color="primary"
            medium
            outlined
            @click="handleSearch($event)"
          >
            {{ $t('Search') }}
          </v-btn>
        </v-col>
    </v-row>
    <datatable ref="projectsDatatable" :config="configDatatale"/>
    <dialog-delete ref="dialogDelete" @yes="deleteItem"/>
  </div>
</template>

<script>
import Datatable from '@/components/Datatable'
import Datepicker from '@/components/Datepicker'
import DialogDelete from '@/components/DialogDelete'
import { utcToLocal } from '@utils'
import { get, call } from 'vuex-pathify'

export default {
  name: 'ProjectIndex',
  components: {
    Datatable,
    Datepicker,
    DialogDelete
  },
  data: (vm) => ({
    configDatatale: {
      url: '/api/projects/datatable',
      operations: [
        {
          color: 'primary',
          text: 'View',
          icon: 'mdi-eye',
          method: function (item) {
            vm.$router.push({ name: 'projects.show', params: { id: item.id } })
          }
        },
        {
          color: 'warning',
          icon: 'mdi-pencil',
          text: 'Edit',
          hide: function (item) {
            return ['completed', 'reviewed'].includes(item?.status)
          },
          method: function (item) {
            vm.$router.push({ name: 'projects.edit', params: { id: item.id } })
          }
        },
        {
          color: 'error',
          icon: 'mdi-delete',
          text: 'Delete',
          hide: function (item) {
            return ['completed', 'reviewed'].includes(item?.status)
          },
          method: function (item) {
            vm.$refs.dialogDelete.confirm(item)
          }
        }
      ],
      columns: [
        {
          text: 'ID',
          data: 'id',
          name: 'id'
        },
        {
          text: vm.$t('Code'),
          data: 'code',
          name: 'code',
          component: true,
          render: function(item, column) {
            if (!item) {
              return null
            }
            return `<router-link :to="{ name: 'projects.show', params: {id:${item.id}} }">${item[column]}</router-link>`
          }
        },
        {
          text: vm.$t('Name'),
          data: 'name',
          name: 'name',
          component: true,
          render: function(item, column) {
            if (!item) {
              return null
            }
            return `<router-link :to="{ name: 'projects.show', params: {id:${item.id}} }">${item[column]}</router-link>`
          }
        },
        {
          text: vm.$t('Type'),
          data: 'type',
          name: 'type',
          render: function(item, column) {
            if (!item) {
              return null
            }
            return vm.__attr(item[column])
          }
        },
        {
          text: vm.$t('Status'),
          data: 'status',
          name: 'status',
          html: true,
          render: function(item, column) {
            if (!item) {
              return null
            }
            return `<span class='color-status ${item[column]}'>${vm.__attr(item[column])}</span>`
          }
        },
        {
          text: vm.$t('Created at'),
          data: 'created_at',
          name: 'created_at',
          render: function(item, column) {
            if (!item) {
              return null
            }
            return utcToLocal(item[column], 'DD/MM/YYYY HH:mm')
          }
        },
        {
          text: vm.$t('Operations'),
          data: '_operations',
          name: null,
          searchable: false,
          orderable: false,
          search: {
            value: null,
            regex: false
          }
        }
      ],
      setting: {
        displaySearchInput: false,
        operationStyle: 'default'
      },
      paramsRequest: {
        status: '',
        from_date: null,
        to_date: null,
        _search: null
      }
    }
  }),
  computed: {
    ...get('common', [
      'project_status'
    ]),
    statusFillter() {
      return [
        {
          text: 'All',
          value: ''
        },
        ...this.project_status
      ]
    }
  },
  methods: {
    handleDelete: call('project/delete'),
    loading: call('app/setLoading'),
    showNotify: call('notify/show'),
    async deleteItem(item) {
      this.loading(true)
      const res = await this.handleDelete(item.id)
      this.loading(false)
      if (res) {
        const { message } = res
        this.showNotify(message)
        this.$refs.projectsDatatable.fetchData()
      } else {
        this.showNotify(this.$t('Something went wrong.'))
      }
    },
    handleSearch(e) {
      e.preventDefault()
      const filter = {
        ...this.configDatatale.paramsRequest
      }
      this.$refs.projectsDatatable.setParamsRequest(filter)
      this.$refs.projectsDatatable.fetchData()
      return false
    }
  }
}
</script>
